export default "__VITE_ASSET__1e6ebcb0__"